import {
  Badge,
  Button,
  Drawer,
  IconButton,
  Box,
  styled,
} from '@mui/material';
import { Fragment, useState } from 'react';
import { H2 } from '../global';
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";

const Notification = styled('div')(() => ({
  padding: '25px',
  marginBottom: '25px',
  display: 'flex',
  alignItems: 'center',
  height: 50,
}));

// const NotificationCard = styled(Box)(({ theme }) => ({
//   position: 'relative',
//   '&:hover': {
//     '& .messageTime': {
//       display: 'none'
//     },
//     '& .deleteButton': {
//       opacity: '1'
//     }
//   },
//   '& .messageTime': {
//     color: theme.palette.text.secondary
//   },
//   '& .icon': { fontSize: '1.25rem' }
// }));

// const DeleteButton = styled(IconButton)(({ theme }) => ({
//   opacity: '0',
//   position: 'absolute',
//   right: 5,
//   marginTop: 9,
//   marginRight: '24px',
//   background: 'rgba(0, 0, 0, 0.01)'
// }));

// const CardLeftContent = styled('div')(({ theme }) => ({
//   padding: '12px 8px',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'space-between',
//   background: 'rgba(0, 0, 0, 0.01)',
//   '& small': {
//     fontWeight: '500',
//     marginLeft: '16px',
//     color: theme.palette.text.secondary
//   }
// }));

// const Heading = styled('span')(({ theme }) => ({
//   fontWeight: '500',
//   marginLeft: '16px',
//   color: theme.palette.text.secondary
// }));

export const NotificationBar = ({ container }) => {

  const [panelOpen, setPanelOpen] = useState(false);
  // const { deleteNotification, clearNotifications, notifications } = useNotification();

  const handleDrawerToggle = () => {
    setPanelOpen(!panelOpen);
  };

  //const textColor = colors.primary[400];

  return (
    <Fragment>
      <IconButton onClick={handleDrawerToggle}>
        <Badge color="secondary" badgeContent={6 /* notifications?.length */}>
          
{/* 
  <IconButton type="button" onClick={ <NotificationBar />}>
    <NotificationsOutlinedIcon />
  </IconButton>
*/}          
          <NotificationsOutlinedIcon />
        </Badge>
      </IconButton>

        <Drawer
          width={'100px'}
          container={container}
          variant="temporary"
          anchor={'right'}
          open={panelOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true
          }}
        >
          <Box sx={{ width: 250 }}>
            <Notification >
              <NotificationsOutlinedIcon />
              <H2 ml={1} mt={1} mb={1}>Notifications</H2>
            </Notification>

{/*             {notifications?.map((notification) => (
              <NotificationCard key={notification.id}>
                <DeleteButton
                  size="small"
                  className="deleteButton"
                  //onClick={() => deleteNotification(notification.id)}
                >
                  <Icon className="icon">clear</Icon>
                </DeleteButton>
                <Link
                  to={`/${notification.path}`}
                  onClick={handleDrawerToggle}
                  style={{ textDecoration: 'none' }}
                >
                  <Card sx={{ mx: 2, mb: 3 }} elevation={3}>
                    <CardLeftContent>
                      <Box display="flex">
                        <Icon className="icon" color={notification.icon.color}>
                          {notification.icon.name}
                        </Icon>
                        <Heading>{notification.heading}</Heading>
                      </Box>
                      <Small className="messageTime">
                        {getTimeDifference(new Date(notification.timestamp))}
                        ago
                      </Small>
                    </CardLeftContent>
                    <Box sx={{ px: 2, pt: 1, pb: 2 }}>
                      <Paragraph sx={{ m: 0 }}>{notification.title}</Paragraph>
                      <Small sx={{ color: secondary }}>{notification.subtitle}</Small>
                    </Box>
                  </Card>
                </Link>
              </NotificationCard>
            ))} */}
            {/* !!notifications?.length */ 6 && (
              <Box sx={{ mx: 2, mb: 3 }} >
                <Button /* onClick={clearNotifications} */ color="primary" >Clear</Button>
              </Box>
            )}
          </Box>
        </Drawer>

    </Fragment>
  );
};

